import { FormLabel, TextField } from '@mui/material';
import { ProfileStepIds } from '@/models/recommendation';
import { BaseQuestion } from '@/packages/profile-quiz/components/questions/base-question';
import { useProfileQuiz } from '@/packages/profile-quiz/context/profile-quiz';
import {
  type QuestionProps,
  ProfileFields,
} from '@/packages/profile-quiz/context/profile-quiz/types';

export const ContactInfoStep = (_props: QuestionProps) => {
  const { answers, setQuizAnswer } = useProfileQuiz();

  const setContactInfo = (question: ProfileFields, value: string) => {
    setQuizAnswer(question, value);
    setQuizAnswer(ProfileFields.AgreedToReceiveEmails, true);
  };

  return (
    <BaseQuestion
      questionTitle="💬 E como prefere que a gente mantenha contato? Assim posso te enviar atualizações e recomendações de conteúdos que façam sentido pra sua jornada."
      questionId={ProfileStepIds.ContactInfo}
      processedResponseText="Tudo certo! Agora é hora de começar sua jornada com uma experiência feita sob medida pro seu desenvolvimento profissional. Vamos nessa? 🚀"
    >
      <FormLabel>Whatsapp</FormLabel>
      <TextField
        fullWidth
        placeholder="(11) 91234-5678"
        value={answers.phone}
        onChange={(e) => setContactInfo(ProfileFields.Phone, e.target.value)}
      />

      <FormLabel>E-mail pessoal</FormLabel>
      <TextField
        fullWidth
        placeholder="seu@email.com"
        value={answers.email}
        onChange={(e) => setContactInfo(ProfileFields.Email, e.target.value)}
      />
    </BaseQuestion>
  );
};
